'use client';

import { Box, Typography } from '@mui/material';

import GlobalBlockRenderer from '@/components/ContentBlocks/GlobalBlockRenderer/GlobalBlockRenderer';
import { TwoColumnTextImageContent } from '@/components/ContentBlocks/TwoColumnTextImageBlock/TwoColumnTextImageContent';
import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';
import {
  ComponentBlocksTwoColumnTextImageBlock,
  Enum_Componentshareddisplayoptions_Contentswidth,
} from '@/types';

interface Props {
  block: ComponentBlocksTwoColumnTextImageBlock | null;
}

export function TwoColumnTextImageBlock({ block }: Props) {
  if (!block) return null;

  const { TwoColumnTitle = undefined, TwoColumnBlurb = undefined } = block;

  return (
    <CustomBackground
      backgroundOptions={(block?.TwoColumnBackground ?? undefined) as StrapiBackgroundOptions}
      displayOptions={
        (block?.TwoColumnDisplayOptions ?? {
          ContentsWidth: Enum_Componentshareddisplayoptions_Contentswidth.Wide,
          PaddingTop: 'md',
          PaddingBottom: 'md',
          PaddingInline: 'sm',
        }) as StrapiDisplayOptions
      }
      boxProps={{ sx: { borderRadius: '2rem !important' } }}
    >
      <Box data-component="TwoColumnTextImageBlock">
        {/* Hero Blurb */}
        {(TwoColumnTitle || TwoColumnBlurb) && (
          <Box
            sx={{
              mb: 6,
              maxWidth: block?.TwoColumnDisplayOptions?.ContentsWidth ?? 'md',
              mx: 'auto',
            }}
          >
            {/* Title */}
            {TwoColumnTitle && (
              <Typography variant="h2" sx={{}}>
                {TwoColumnTitle}
              </Typography>
            )}
            {TwoColumnBlurb && <GlobalBlockRenderer content={TwoColumnBlurb} />}
          </Box>
        )}

        <TwoColumnTextImageContent block={block} />
      </Box>
    </CustomBackground>
  );
}
